import { Helmet } from '@dr.pogodin/react-helmet';
import { Link } from 'react-router';
import NoticeSiteHasBeenArchived from '../common/lib/NoticeSiteHasBeenArchived';
import type { MultiLang } from '../config';
import Functions from '../functions';
import './assets/pubmedpdf.css';
import PubmedPdfBreadcrumbs from './lib/PubmedPdfBreadcrumbs';
import PubmedPdfUtils, { type PubmedPdfBreadcrumbsData } from './lib/PubmedPdfUtils';

interface Props {
    lang: MultiLang;
    initial: string;
}

const PubmedPdfAuthorsByInitial = (props: Props) => {
    const { lang, initial } = props;
    const name = PubmedPdfUtils.getName();
    const mtitle = Functions.mlang(name, lang);
    const authors = PubmedPdfUtils.getAuthors(initial);
    const breadcrumbs: PubmedPdfBreadcrumbsData[] = [
        { id: `a-${initial}`, name: initial, link: PubmedPdfUtils.getAuthorInitialUrl(initial) },
    ];
    return (
        <div className="pubmedpdf">
            <Helmet>
                <title>
                    {mtitle} - {Functions.siteTitle(lang)}
                </title>
            </Helmet>
            <h3>{mtitle}</h3>
            <NoticeSiteHasBeenArchived lang={lang} />
            <PubmedPdfBreadcrumbs lang={lang} breadcrumbs={breadcrumbs} />
            <hr />
            <div className="authors">
                <div className="author-group">
                    {authors.map((author) => {
                        return (
                            <span className="author" key={author.id}>
                                <Link to={PubmedPdfUtils.getAuthorUrl(author.id, 0)}>
                                    {Functions.mlang(author.name, lang)}
                                </Link>{' '}
                                ({author.count})
                            </span>
                        );
                    })}
                </div>
            </div>
            <hr />
        </div>
    );
};

export default PubmedPdfAuthorsByInitial;
